// LIBRARIES //
import React from 'react';
import styled from 'styled-components';
import Lottie from 'react-lottie';

// COMPONENTS //
import CtaPrimary from 'components/ui/CtaPrimary';
import Spacer from 'components/ui/Spacer';

// HELPERS //
import successAnimationData from 'assets/success.json';
import { getTranslatedString } from 'helpers/i18n';
import errorAnimationData from 'assets/error.json';
import { GOOGLE_REVIEW_ERROR } from './index';

const StyledResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px;
`;

const StyledResponseHeading = styled.div`
  font-size: 28px;
  font-family: 'Circular-Black';
`;

export const GoogleReviewResponse = ({
  disableConfirmation,
  handleClose,
  googleFormStep,
  rating,
}) => {
  let animiationData = successAnimationData;
  let heading = getTranslatedString(
    `landlordPortal.properties.googleReviewsDialog.successfullyTitle.${!disableConfirmation
      ? 'enable'
      : 'disable'}`
  );
  let verbiage = getTranslatedString(
    `landlordPortal.properties.googleReviewsDialog.successfullyDescription.${!disableConfirmation
      ? 'enable'
      : 'disable'}`,
    { rating }
  );
  if (googleFormStep === GOOGLE_REVIEW_ERROR) {
    animiationData = errorAnimationData;
    heading = getTranslatedString(
      'landlordPortal.properties.newMaintenanceCustomMessageDialog.whoops'
    );
    verbiage = getTranslatedString('landlordPortal.properties.googleReviewsDialog.weWereUnable');
  }
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animiationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <StyledResponseContainer>
      <Lottie options={defaultOptions} height={150} width={150} />
      <StyledResponseHeading>{heading}</StyledResponseHeading>
      <Spacer mb={1} style={{ textAlign: 'center' }}>
        <div>{verbiage}</div>
      </Spacer>
      <CtaPrimary onClick={handleClose}>{getTranslatedString('close')}</CtaPrimary>
    </StyledResponseContainer>
  );
};
